import { buildUpsellPaymentPayload } from '@/modules/upsell/domain/builders/upsellPaymentBuilder';
import { Helpers } from '@/services/helpers';
import URLS from '@/services/urls';

import {
  SET_DIGITAL_UPSELL_VARIANT,
  SET_UPSELL_ADDRESS,
  SET_UPSELL_ORDERS,
  SET_UPSELL_PAGE_PROPS,
  SET_UPSELL_PREVIOUS_ORDER_ID,
  SET_UPSELL_STANDALONE,
  SET_UPSELL_STANDALONE_BOUGHT,
  SET_UPSELL_UPDATED_ORDERS,
} from '../mutation-types';

/**
 * Set upsell selected products to has been added to cart
 * @param {function} commit - The vuex commit function
 * @param {Object} payload - Product information
 * @return {Object} Contain Product information
 */
export function setUpsellCartProductsAction({ commit }, payload) {
  commit(SET_UPSELL_ORDERS, payload);
}

/**
 * Update upsell products to has been added to cart
 * @param {function} commit - The vuex commit function
 * @param {Object[]} payload - Products information
 * @return {Object[]} Contain Products information
 */
export function updateUpsellCartProductsAction({ commit }, payload) {
  commit(SET_UPSELL_UPDATED_ORDERS, payload);
}

/**
 * Set shipping details form
 * @param {function} commit - The vuex commit function
 * @param {Object} payload - Shipping details information
 * @return {Object} Contain shipping details information
 */
export function setShippingDetailsAction({ commit }, payload) {
  commit(SET_UPSELL_ADDRESS, payload);
}

/**
 *  Send upsell orders and shipping details to backend
 * @param {function} commit - The vuex commit function
 * @param {Object} state - The vuex state object
 * @param {Object} rootState - The vuex root state object
 * @param {Object} payload - { isDonation: [true/false], token: 'paymentToken' }
 * @return {any}
 */
export async function sendUpsellPaymentAction({ state, rootState }, payload = {}) {
  const finalPayload = buildUpsellPaymentPayload({ state, rootState, payload });
  const response = await this.$api.$post(URLS.UPSELL_PAYMENT, finalPayload);

  return response;
}

export async function purchaseUpsellAction({ state, rootState }) {
  const { uuid } = rootState['have-lead'];
  const siteCountry = Helpers.getCountryFromUrl();
  const { email, firstName, lastName, payment } = rootState.payment.paymentPayload;

  const upsellPayload = {
    firstName,
    lastName,
    email,
    orders: state.upsellPayload.orders,
    payment: {
      method: payment.method,
      type: payment.type,
      orderId: String(payment.orderId),
      previousOrderId: String(payment.orderId),
      transactionId: payment.transactionId,
      digitalUpsellVariant: state.upsellPayload.payment.digitalUpsellVariant,
    },
    siteCountry,
    uuid,
    upsellDownsale: state.upsellPayload.upsellDownsale,
  };

  const data = await this.$api.$post(URLS.UPSELL_SUBSCRIPTION_PAYMENT, upsellPayload);

  return data.upsellId;
}

/**
 *  Send upsell purchase endpoint to create shopify physical products
 * @param {Object} rootState - The vuex root state object
 * @param {String} upsellId - Upsell id would be returned from /upsell_payment
 * @return {any}
 */
export async function sendUpsellPurchaseAction({ rootState }, { upsellId }) {
  const {
    payment: {
      paymentPayload: { email, payment },
    },
  } = rootState;

  const { variant } = payment;
  const data = await this.$api.$post(URLS.UPSELL_PURCHASE, { variant, email, upsellId });
  return Helpers.resolvePromise(data);
}

/**
 * Set upsell component page props an example: {pageType: "wp", class: "upsell--wp"} || { vueProp: vueValue }
 * @param {function} commit - The vuex commit function
 * @param {Object} payload - Upsell page props
 * @return {Object} Upsell page props
 */
export function setUpsellPagePropsAction({ commit }, payload) {
  commit(SET_UPSELL_PAGE_PROPS, payload);
}

/**
 * Set upsell PreviousOrderId from sticky
 * @param {function} commit - The vuex commit function
 * @param {String} payload - PreviousOrderId value
 * @return {String} Upsell PreviousOrderId
 */
export function setUpsellPreviousOrderIdAction({ commit }, payload) {
  commit(SET_UPSELL_PREVIOUS_ORDER_ID, payload);
}

export function setUpsellStandaloneAction({ commit }, payload) {
  commit(SET_UPSELL_STANDALONE, payload);
}

export function setUpsellStandaloneBoughtAction({ commit }, payload) {
  commit(SET_UPSELL_STANDALONE_BOUGHT, payload);
}

export function setDigitalUpsellVariant({ commit }, payload) {
  commit(SET_DIGITAL_UPSELL_VARIANT, payload);
}
